import { Link } from "react-router-dom"

import useCollection from "areas/collection/hoc/use-collection"
import { cn } from "styles/utils"

const Breadcrumb = () => {
  const { data } = useCollection()
  const breadcrumbs = data?.breadcrumb || []

  return (
    <nav aria-label="Breadcrumb">
      <ol className="text-14 text-grey-500 leading-16 list-none font-medium">
        {breadcrumbs.map((breadcrumb, i) => (
          <li
            className={cn(
              "inline",
              (i !== breadcrumbs.length - 1 || i === 0) &&
                "after:px-4 after:content-['/']"
            )}
            key={`breadcrumb_${breadcrumb.name}`}
          >
            {breadcrumb.url ? (
              <Link data-lc="breadcrumb" to={breadcrumb.url}>
                {breadcrumb.name}
              </Link>
            ) : (
              <>{breadcrumb.name}</>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
